module.exports = function date(input, format) {
  return window.moment(input).format(format)
}
